var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shortMessage"},[_c('top-nav',{attrs:{"banner":_vm.shortMessage.banner,"isParent":""}}),_vm._v(" "),_c('pain'),_vm._v(" "),_c('application'),_vm._v(" "),_c('solution'),_vm._v(" "),_c('product-list'),_vm._v(" "),_c('customer-wall'),_vm._v(" "),_c('footer-resolution'),_vm._v(" "),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }